import {getConfigFields} from '../fields.js'
import {formFieldIds} from '../values.js'

const {phone, plate, vehicleStatus} = formFieldIds

const formAppraiserLandingVehicleExtraDataFieldsConfig = [
  getConfigFields[plate]({customProps: {help: 'INSTANT_OFFER.LANDING.PLATE_HELP_APPRAISER'}}),
  getConfigFields[vehicleStatus](),
  getConfigFields[phone]({customProps: {help: 'INSTANT_OFFER.LANDING.PHONE_HELP_APPRAISER'}})
]

export const formAppraiserLandingVehicleExtraDataConfig = {
  fields: formAppraiserLandingVehicleExtraDataFieldsConfig
}
